import { ScheduleApiFactory, ScheduleAnserGet, ScheduleAnswerApplicantSend, ScheduleAnswerSend } from '@/api'
import { BaseInitRequest, BaseUserActionRequest } from '@/requests/baseRequest'
import { AxiosPromise } from 'axios'

/**
 * 回答取得
 */
export class ListRequest extends BaseInitRequest {
  private messageId: number
  constructor(messageId: number) {
    super()
    this.messageId = messageId
  }

  protected request(): AxiosPromise<ScheduleAnserGet[]> {
    const api = ScheduleApiFactory()
    return api.scheduleAnswerList(String(this.messageId))
  }
}

/**
 * 協議者側回答更新
 */
export class ApplicantUpdateRequest extends BaseUserActionRequest {
  private scheduleInquiryId: number
  private scheduleAnswer: ScheduleAnswerApplicantSend
  constructor(scheduleInquiryId: number, scheduleAnswer: ScheduleAnswerApplicantSend) {
    super()
    this.scheduleInquiryId = scheduleInquiryId
    this.scheduleAnswer = scheduleAnswer
  }

  protected request(): AxiosPromise<ScheduleAnswerApplicantSend> {
    const api = ScheduleApiFactory()
    return api.scheduleAnswerApplicantSendUpdate(this.scheduleInquiryId, this.scheduleAnswer)
  }
}

/**
 * Jr回答者情報取得
 */
export class JrScheduleAnswerRequest extends BaseInitRequest {
  private messageId: number
  private shain_code: string
  constructor(messageId: number, shainCode: string) {
    super()
    this.messageId = messageId
    this.shain_code = shainCode
  }

  protected request(): AxiosPromise<ScheduleAnserGet[]> {
    const api = ScheduleApiFactory()
    return api.scheduleAnswerList(String(this.messageId), String(this.shain_code))
  }
}

/**
 * Jr側回答更新
 */
export class JrUpdateRequest extends BaseUserActionRequest {
  private scheduleInquiryId: number
  private scheduleAnswer: ScheduleAnswerSend
  constructor(scheduleInquiryId: number, scheduleAnswer: ScheduleAnswerSend) {
    super()
    this.scheduleInquiryId = scheduleInquiryId
    this.scheduleAnswer = scheduleAnswer
  }

  protected request(): AxiosPromise<ScheduleAnswerSend> {
    const api = ScheduleApiFactory()
    return api.scheduleAnswerSendUpdate(this.scheduleInquiryId, this.scheduleAnswer)
  }
}
